/**
 * Entidade de domínio que representa o status de rede do dispositivo.
 * Puro TypeScript — sem dependência de framework.
 */
export type NetworkStatusValue = 'online' | 'offline';

export interface NetworkStatus {
  readonly value: NetworkStatusValue;
  readonly checkedAt: Date;
}

export function createNetworkStatus(isOnline: boolean): NetworkStatus {
  return {
    value: isOnline ? 'online' : 'offline',
    checkedAt: new Date(),
  };
}

export function isOnline(status: NetworkStatus): boolean {
  return status.value === 'online';
}
